import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";

export const ADD_PROBLEM = 'ADD_PROBLEM';
export const UPDATE_PROBLEM = 'UPDATE_PROBLEM';
export const GET_PROBLEM = 'GET_PROBLEM';
export const DELETE_PROBLEM = 'DELETE_PROBLEM';
export const SEARCH_PROBLEM = 'SEARCH_PROBLEM';
export const ADD_DOCTOR = 'ADD_DOCTOR';
export const GET_DOCTOR = 'GET_DOCTOR';
export const DELETE_DOCTOR = 'DELETE_DOCTOR';
export const SEARCH_DOCTOR = 'SEARCH_DOCTOR';
export const UPDATE_DOCTOR = 'UPDATE_DOCTOR';
export const ADD_MEDICAL = 'ADD_MEDICAL';
export const GET_MEDICAL = 'GET_MEDICAL';
export const SEARCH_MEDICAL = 'SEARCH_MEDICAL';
export const UPDATE_MEDICAL = 'UPDATE_MEDICAL';
export const DELETE_MEDICAL = 'DELETE_MEDICAL';
export const ADD_THERAPIST = 'ADD_THERAPIST';
export const GET_THERAPIST = 'GET_THERAPIST';
export const SEARCH_THERAPIST = 'SEARCH_THERAPIST';
export const UPDATE_THERAPIST = 'UPDATE_THERAPIST';
export const DELETE_THERAPIST = 'DELETE_THERAPIST';
export const ADD_BRANCH = 'ADD_BRANCH';
export const GET_BRANCH = 'GET_BRANCH';
export const SEARCH_BRANCH = 'SEARCH_BRANCH';
export const UPDATE_BRANCH = 'UPDATE_BRANCH';
export const DELETE_BRANCH = 'DELETE_BRANCH';
export const ADD_SERVICE = 'ADD_SERVICE';
export const GET_SERVICE = 'GET_SERVICE';
export const SEARCH_SERVICE = 'SEARCH_SERVICE';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const DELETE_SERVICE = 'DELETE_SERVICE';
export const ADD_COUNSELOR = 'ADD_COUNSELOR';
export const GET_COUNSELOR = 'GET_COUNSELOR';
export const SEARCH_COUNSELOR = 'SEARCH_COUNSELOR';
export const UPDATE_COUNSELOR = 'UPDATE_COUNSELOR';
export const DELETE_COUNSELOR = 'DELETE_COUNSELOR';
export const ADD_PACKAGE = 'ADD_PACKAGE';
export const GET_PACKAGE = 'GET_PACKAGE';
export const SEARCH_PACKAGE = 'SEARCH_PACKAGE';
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE';
export const DELETE_PACKAGE = 'DELETE_PACKAGE';
export const ADMIN_USER = 'ADMIN_USER';
export const ADMIN_GET = 'ADMIN_GET';
export const ADMIN_UPDATE = 'ADMIN_UPDATE';
export const ADMIN_DELETE = 'ADMIN_DELETE';
export const ADMIN_SEARCH = 'ADMIN_SEARCH';
export const ADD_DIAGNOSIS = 'ADD_DIAGNOSIS';
export const GET_DIAGNOSIS = 'GET_DIAGNOSIS';
export const SEARCH_DIAGNOSIS = 'SEARCH_DIAGNOSIS';
export const UPDATE_DIAGNOSIS = 'UPDATE_DIAGNOSIS';
export const DELETE_DIAGNOSIS = 'DELETE_DIAGNOSIS';

export const GET_INCOMING_CALL = 'GET_INCOMING_CALL';
export const SEARCH_INCOMING_CALL = 'SEARCH_INCOMING_CALL';

const problemAddAction = (payload) => ({ type: ADD_PROBLEM, payload: payload });
const problemUpdateAction = (payload) => ({ type: UPDATE_PROBLEM, payload: payload });
const problemGetAction = (payload) => ({ type: GET_PROBLEM, payload: payload });
const problemDeleteAction = (payload) => ({ type: DELETE_PROBLEM, payload: payload });
const problemSearchAction = (payload) => ({ type: SEARCH_PROBLEM, payload: payload });
const addDoctorAction = (payload) => ({ type: ADD_DOCTOR, payload: payload });
const getDoctorAction = (payload) => ({ type: GET_DOCTOR, payload: payload });
const deleteDocterAction = (payload) => ({ type: DELETE_DOCTOR, payload: payload });
const searchDocterAction = (payload) => ({ type: SEARCH_DOCTOR, payload: payload });
const updateDocterAction = (payload) => ({ type: UPDATE_DOCTOR, payload: payload });
const addMedicalAction = (payload) => ({ type: ADD_MEDICAL, payload: payload });
const getMedicalAction = (payload) => ({ type: GET_MEDICAL, payload: payload });
const searchMedicalAction = (payload) => ({ type: SEARCH_MEDICAL, payload: payload });
const updateMedicalAction = (payload) => ({ type: UPDATE_MEDICAL, payload: payload });
const deleteMedicalAction = (payload) => ({ type: DELETE_MEDICAL, payload: payload });
const addTherapistAction = (payload) => ({ type: ADD_THERAPIST, payload: payload });
const getTherapistAction = (payload) => ({ type: GET_THERAPIST, payload: payload });
const searchTherapistAction = (payload) => ({ type: SEARCH_THERAPIST, payload: payload });
const updateTherapistAction = (payload) => ({ type: UPDATE_THERAPIST, payload: payload });
const deleteTherapistAction = (payload) => ({ type: DELETE_THERAPIST, payload: payload });
const addBranchAction = (payload) => ({ type: ADD_BRANCH, payload: payload });
const getBranchAction = (payload) => ({ type: GET_BRANCH, payload: payload });
const searchBranchAction = (payload) => ({ type: SEARCH_BRANCH, payload: payload });
const updateBranchAction = (payload) => ({ type: UPDATE_BRANCH, payload: payload });
const deleteBranchAction = (payload) => ({ type: DELETE_BRANCH, payload: payload });
const addServiceAction = (payload) => ({ type: ADD_SERVICE, payload: payload });
const getServiceAction = (payload) => ({ type: GET_SERVICE, payload: payload });
const searchServiceAction = (payload) => ({ type: SEARCH_SERVICE, payload: payload });
const updateServiceAction = (payload) => ({ type: UPDATE_SERVICE, payload: payload });
const deleteServiceAction = (payload) => ({ type: DELETE_SERVICE, payload: payload });
const addCounselorAction = (payload) => ({ type: ADD_COUNSELOR, payload: payload });
const getCounselorAction = (payload) => ({ type: GET_COUNSELOR, payload: payload });
const searchCounselorAction = (payload) => ({ type: SEARCH_COUNSELOR, payload: payload });
const updateCounselorAction = (payload) => ({ type: UPDATE_COUNSELOR, payload: payload });
const deleteCounselorAction = (payload) => ({ type: DELETE_COUNSELOR, payload: payload });
const addPackageAction = (payload) => ({ type: ADD_PACKAGE, payload: payload });
const getPackageAction = (payload) => ({ type: GET_PACKAGE, payload: payload });
const searchPackageAction = (payload) => ({ type: SEARCH_PACKAGE, payload: payload });
const updatePackageAction = (payload) => ({ type: UPDATE_PACKAGE, payload: payload });
const deletePackageAction = (payload) => ({ type: DELETE_PACKAGE, payload: payload });
const adminUserAction = (payload) => ({ type: ADMIN_USER, payload: payload });
const adminGetAction = (payload) => ({ type: ADMIN_GET, payload: payload });
const adminUpdateAction = (payload) => ({ type: ADMIN_UPDATE, payload: payload });
const adminDeleteAction = (payload) => ({ type: ADMIN_DELETE, payload: payload });
const adminSearchAction = (payload) => ({ type: ADMIN_SEARCH, payload: payload });
const addDiagnosisAction = (payload) => ({ type: ADD_DIAGNOSIS, payload: payload });
const getDiagnosisAction = (payload) => ({ type: GET_DIAGNOSIS, payload: payload });
const searchDiagnosisAction = (payload) => ({ type: SEARCH_DIAGNOSIS, payload: payload });
const updateDiagnosisAction = (payload) => ({ type: UPDATE_DIAGNOSIS, payload: payload });
const deleteDiagnosisAction = (payload) => ({ type: DELETE_DIAGNOSIS, payload: payload });
const getIncomingCallAction = (payload) => ({ type: GET_INCOMING_CALL, payload: payload });
const searchIncomingCallAction = (payload) => ({ type: SEARCH_INCOMING_CALL, payload: payload });

export const addAdmin = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/auth/register`, payload).then(((res) => {
                toast.success('Add Admin User successfully')
                dispatch(adminUserAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminUserAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getAdmin = (limits) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/auth/ViewAuth?limit=${limits.limit}&page=${limits.page}`).then(((res) => {
                dispatch(adminGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(adminGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchAdmin = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/auth/searchAuth?limit=10&${queryParams}`).then(((res) => {
                dispatch(adminSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(adminSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateAdmin = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/auth/UpdateAuth`, payload).then(((res) => {
                toast.success('Update Auth successfully')
                dispatch(adminUpdateAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteAdmin = (problemId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/auth/DeleteAuth/${problemId}`).then(((res) => {
                toast.success('Delete Auth successfully')
                dispatch(adminDeleteAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addProblem = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addProblem`, payload).then(((res) => {
                toast.success('Add Problem successfully')
                dispatch(problemAddAction(res));
                dispatch(getProblem(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(problemAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getProblem = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllProblem?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(problemGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(problemGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateProblem = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateProblem`, payload).then(((res) => {
                toast.success('Update Problem successfully')
                dispatch(problemUpdateAction(res));
                dispatch(getProblem(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(problemUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteProblem = (problemId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteProblem/${problemId}`).then(((res) => {
                toast.success('Delete Problem successfully')
                dispatch(problemDeleteAction(res));
                dispatch(getProblem(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(problemDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchProblem = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchProblem?limit=10&${queryParams}`).then(((res) => {
                dispatch(problemSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(problemSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const addDoctor = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerDoctor`, payload).then(((res) => {
                toast.success('Add Doctor successfully')
                dispatch(addDoctorAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addDoctorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getDoctor = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllDoctor?limit=10&page=${payload.page}`).then(((res) => {
                dispatch(getDoctorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getDoctorAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const deleteDoctor = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteDoctor/${updateId}`).then(((res) => {
                toast.success('Delete Doctor successfully')
                dispatch(deleteDocterAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteDocterAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchDoctor = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchDoctor?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchDocterAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchDocterAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateDoctor = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateDoctor`, payload).then(((res) => {
                toast.success('Update Doctor successfully')
                dispatch(updateDocterAction(res));   
                dispatch(getDoctor(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateDocterAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addMedical = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerMedicine`, payload).then(((res) => {
                toast.success('Add Medicine List successfully')
                dispatch(addMedicalAction(res));
                dispatch(getMedical(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addMedicalAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getMedical = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllMedicine?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(getMedicalAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getMedicalAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchMedicial = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchMedicine?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchMedicalAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchMedicalAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateMedicial = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateMedicine`, payload).then(((res) => {
                toast.success('Update Medicine List successfully')
                dispatch(updateMedicalAction(res));   
                dispatch(getMedical(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateMedicalAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteMedicial = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteMedicine/${updateId}`).then(((res) => {
                toast.success('Delete Medicine successfully')
                dispatch(deleteMedicalAction(res));
                dispatch(getMedical(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteMedicalAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addTherapist = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addTherapist`, payload).then(((res) => {
                toast.success('Add Therapist successfully')
                dispatch(addTherapistAction(res));
                dispatch(getTherapist(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addTherapistAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getTherapist = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllTherapist`).then(((res) => {
                dispatch(getTherapistAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getTherapistAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchTherapist = (params) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchTherapist?search=${params.search}`).then(((res) => {
                dispatch(searchTherapistAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchTherapistAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateTherapist = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateTherapist`, payload).then(((res) => {
                toast.success('Update Therapist successfully')
                dispatch(updateTherapistAction(res));   
                dispatch(getTherapist(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateTherapistAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteTherapist = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteTherapist/${updateId}`).then(((res) => {
                toast.success('Delete Therapist successfully')
                dispatch(deleteTherapistAction(res));
                dispatch(getTherapist(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteTherapistAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addBranch = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addBranch`, payload).then(((res) => {
                toast.success('Add Branch successfully')
                dispatch(addBranchAction(res));
                dispatch(getBranch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addBranchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getBranch = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllBranches?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(getBranchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getBranchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchBranch = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchBranch?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchBranchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchBranchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateBranch = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateBranch`, payload).then(((res) => {
                toast.success('Update Branch successfully')
                dispatch(updateBranchAction(res));   
                dispatch(getBranch(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateBranchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteBranch = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteBranch/${updateId}`).then(((res) => {
                toast.success('Delete Branch successfully')
                dispatch(deleteBranchAction(res));
                dispatch(getBranch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteBranchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addService = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addService`, payload).then(((res) => {
                toast.success('Add Service successfully')
                dispatch(addServiceAction(res));
                dispatch(getService(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addServiceAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getService = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllServices?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(getServiceAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getServiceAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchService = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchService?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchServiceAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchServiceAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateService = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateService`, payload).then(((res) => {
                toast.success('Update Service successfully')
                dispatch(updateServiceAction(res));   
                dispatch(getService(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateServiceAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteService = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteService/${updateId}`).then(((res) => {
                toast.success('Delete Service successfully')
                dispatch(deleteServiceAction(res));
                dispatch(getService(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteServiceAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addCounselor = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addCounselor`, payload).then(((res) => {
                toast.success('Add Counselor successfully')
                dispatch(addCounselorAction(res));
                dispatch(getCounselor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getCounselor = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllCounselors?limit=10&page=${payload.page}`).then(((res) => {
                dispatch(getCounselorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getCounselorAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchCounselor = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchCounselor?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchCounselorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchCounselorAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateCounselor = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateCounselor`, payload).then(((res) => {
                toast.success('Update Counselor successfully')
                dispatch(updateCounselorAction(res));   
                dispatch(getCounselor(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteCounselor = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteCounselor/${updateId}`).then(((res) => {
                toast.success('Delete Counselor successfully')
                dispatch(deleteCounselorAction(res));
                dispatch(getCounselor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addPackage = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addPackage`, payload).then(((res) => {
                toast.success('Add package successfully')
                dispatch(addPackageAction(res));
                dispatch(getPackage(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addPackageAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getPackage = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllPackage?limit=10&page=${payload.page}`).then(((res) => {
                dispatch(getPackageAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getPackageAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchPackage = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchPackage?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchPackageAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchPackageAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updatePackage = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updatePackage`, payload).then(((res) => {
                toast.success('Update package successfully')
                dispatch(updatePackageAction(res));   
                dispatch(getPackage(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updatePackageAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deletePackage = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deletePackage/${updateId}`).then(((res) => {
                toast.success('Delete package successfully')
                dispatch(deletePackageAction(res));
                dispatch(getPackage(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deletePackageAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addDiagnosis = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addDiagnosis`, payload).then(((res) => {
                toast.success('Add diagnosis successfully')
                dispatch(addDiagnosisAction(res));
                dispatch(getDiagnosis(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getDiagnosis = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllDiagnosis?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(getDiagnosisAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getDiagnosisAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchDiagnosis = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchDiagnosis?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchDiagnosisAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchDiagnosisAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateDiagnosis = (payload,limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateDiagnosis`, payload).then(((res) => {
                toast.success('Update package successfully')
                dispatch(updateDiagnosisAction(res));   
                dispatch(getDiagnosis(limits))        
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteDiagnosis = (updateId,limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteDiagnosis/${updateId}`).then(((res) => {
                toast.success('Delete package successfully')
                dispatch(deleteDiagnosisAction(res));
                dispatch(getDiagnosis(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteDiagnosisAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getIncomingCall = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.get(`${BASEURL}/ctcCalling/incoming-call?limit=${payload.limit}&page=${payload.page}`, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(getIncomingCallAction({
                    data: {
                        incomingCalls: res.data.data,
                        totalCount: res.data.totalCalls,
                        totalPages: res.data.totalPages,
                        currentPage: res.data.currentPage,
                    }
                }));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getIncomingCallAction(error?.response));
            });
        } catch (error) {
            console.log('Error getIncomingCall', error);
        }
    }
}
export const searchIncomingCall = (queryParams) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token');
            await axios.get(`${BASEURL}/ctcCalling/incoming-call?${queryParams}`, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(((res) => {
                dispatch(searchIncomingCallAction({
                    data: {
                        incomingCalls: res.data.data,
                        totalCount: res.data.totalCalls,
                        totalPages: res.data.totalPages,
                        currentPage: res.data.currentPage,
                    }
                }));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchIncomingCallAction(error?.response));
            });
        } catch (error) {
            console.log('Error searchIncomingCall', error);
        }
    }
}